import React, {memo} from "react";
import TitlesModals from "../TitlesModals";
import {useDispatch, useSelector} from "react-redux";
import {handelCloseModalShoppingCard} from "../../../../../redux/actions/modals/modalShoppingCard";
import {
    actionModalChangeAddressChangeLoader,
    actionModalChangeAddressChangeShow
} from "../../../../../redux/actions/modals/modalChangeAddress";
import axios from "axios";
import {BASE_URL, USERS_ADDRESS_GET} from "../../../../../apis";
import {actionGetAddressUser} from "../../../../../redux/actions/user/user";
import {handelCloseModalSelectBaseMarket} from "../../../../../redux/actions/modals/modalSelectBaseMarket";
import swal from 'sweetalert';
import {handelOpenModalLoginAndRegister} from "../../../../../redux/actions/modals/modalLoginAndRegister";
import {FaEdit, FaHome} from "react-icons/all";

const BoxClickChangeAddress = (props) => {
    const dispatch = useDispatch();
    const {destination} = props.data;
    const {activeAddress,token} = useSelector(state => state.user);
    const {textAddress} = useSelector(state => state.guest.address);
    const dataAddress = token ?  activeAddress.address : textAddress;

    const openChangeAddress = () => {
        if (token) {
            apiHandelGetAddress();
            switch (destination) {
                case 'MODAL_CHANGE_SELECT_SHOPPING':
                    dispatch(handelCloseModalSelectBaseMarket());
                    break;
                case 'MODAL_LIST_PRODUCTS_BODY':
                    dispatch(handelCloseModalShoppingCard());
                    break;
                default:
            }
            dispatch(actionModalChangeAddressChangeShow(true,destination));
        } else {
            swal({
                title: "ورود به سایت",
                text: "لطفا ابتدا در سایت وارد شدید",
                buttons: {
                    cancel: "انصراف",
                    confirm: {
                        text: 'ورود',
                        value: "ok",
                    },
                },
                icon: "info",
            }).then((value) => {
                if (value === 'ok') {
                    switch (destination) {
                        case 'MODAL_CHANGE_SELECT_SHOPPING':
                            dispatch(handelCloseModalSelectBaseMarket());
                            break;
                        case 'MODAL_LIST_PRODUCTS_BODY':
                            dispatch(handelCloseModalShoppingCard());
                            break;
                        default:
                    }
                    dispatch(handelOpenModalLoginAndRegister());
                }
            });
        }
    }

    const apiHandelGetAddress = () => {
        dispatch(actionModalChangeAddressChangeLoader(true));
        axios({
            method: 'get',
            url: BASE_URL + USERS_ADDRESS_GET,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': token
            },
        }).then((response) => {
            dispatch(actionModalChangeAddressChangeLoader(false));
            dispatch(actionGetAddressUser(response.data.address));
        });
    };

    return (
        <React.Fragment>
            <TitlesModals>
                <FaHome className={'icon-title-modals'}/>
                <span>آدرس پیش فرض شما</span>
            </TitlesModals>
            <div className={'ml-2'}>
                <div className={'mt-1'}>
                    <span className={'text-success'}>ارسال به : </span>
                    <p className={'d-inline-block'}>
                        {(dataAddress && dataAddress.length) > 43 ?
                            dataAddress.substring(0, 44) + "..." :
                            dataAddress
                        }
                    </p>
                </div>
                <div className={'btn-change-address-modal-shopping-card text-success'} onClick={openChangeAddress}>
                    <FaEdit className={'mr-2'}/>
                    <p className={'d-inline-block'}>تغییر آدرس</p>
                </div>
            </div>
        </React.Fragment>
    );
};

export default memo(BoxClickChangeAddress);
